$(document).ready(function() {

  if($('body').hasClass('um-page-register') && $('.um-field-user_login input').length) {
    var user_name_input = $($('.um-field-user_login input')[0]);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=username',
      success: function (data) {
        if(data) {
          user_name_input.val(data);
        }
      }
    });
  }

  $('.btn--paging').click(function(){
    $('.comment-page').hide();
    $('.comment-page-'+$(this).data('page')).show();
    $('.btn--paging').removeClass('active');
    $(this).addClass('active');
  });

  $('.btn--sofort').click(function() {
    var sofort = $(this).data('sofort');
    var btn = $(this);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=sofort&sofort='+sofort,
      success: function (data) {
        if(data) {
          $('.btn--sofort').removeClass('active');
          btn.addClass('active');
        }
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  });

  $('.btn--rhythm').click(function() {
    var rhythm = $(this).data('rhythm');
    var btn = $(this);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=rhythm&rhythm='+rhythm,
      success: function (data) {
        if(data) {
          $('.btn--rhythm').removeClass('active');
          btn.addClass('active');
        }
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  });

  /*if(!$($('.um-field-organisation input')[0]).is(':checked')) {
    $('.um-field-organisation_name').hide();
  }*/

  $('.um-profile input[type="submit"]').click(function(e) {
    e.preventDefault();
    var post_fields = '';
    $('.um-profile-body .um-field').each(function() {
      if($(this).data('key') == 'description') {
        var post_val = $(this).find('textarea').val();
      }
      else if($(this).data('key') == 'organisation') {
        if($(this).find('input').is(':checked')) {
          var post_val = $(this).find('input').val();
        }
        else {
          var post_val = '0';
        }
      }
      else if($(this).data('key') == 'email_verbergen' || $(this).data('key') == 'telefon_verbergen') {
        if($(this).find('input').is(':checked')) {
          var post_val = 'Im Profil verbergen';
        }
        else {
          var post_val = '0';
        }
      }
      else {
        var post_val = $(this).find('input').val();
      }
      //if(post_val != '') {
        post_fields += '&'+$(this).data('key')+'='+post_val;
      //}
    })
    //console.log(post_fields);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=profile'+post_fields,
      success: function (data) {
        if(data) {
          location.reload();
        }
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  });

  $('.edit--profile').click(function() {
    $('.profile--display').hide();
    $('.um-profile-body').show();
  });

  $('.btn-eight').click(function() {
    $('.aftereight').removeClass('aftereight');
    $(this).hide();
  });

  var ori = $('.um-field-terms .um-field-label label').html();
  if(ori) {
    $('html:lang(de-CH) .um-field-terms .um-field-label label').html(ori.replace('Nutzungsbedingungen','<a href="/de/agb">Nutzungsbedingungen</a>'));
    $('html:lang(fr-FR) .um-field-terms .um-field-label label').html(ori.replace('conditions générales','<a href="/fr/agb">conditions générales</a>'));
    $('html:lang(it-IT) .um-field-terms .um-field-label label').html(ori.replace("condizioni d’uso","<a href='/it/agb'>condizioni d’uso</a>"));
  }
  var pwlink = $('.um-login .um-link-alt');
  if(pwlink && pwlink.length && pwlink.length > 0) {
    $('html:lang(fr-FR) .um-login .um-link-alt').attr('href','/fr/password-reset');
    $('html:lang(it-IT) .um-login .um-link-alt').attr('href','/it/password-reset');
  }

  if($('.page-template-page-registered #gform_1').length) {
    $("#gform_1").trigger("submit",[true]);
  }

  $('a.member--tip').each(function() {
    var fullname = $(this).data('fullname');
    if(fullname) {
      var d = document.createElement('span');
      d.classList.add('map-tooltip');
      d.innerText = fullname;
      var t = tippy('#'+$(this).attr('id'), {
        arrow: true,
        allowHTML: true,
        followCursor: true,
        html: d,
      });
    }
  });

  $('p.tag--tip').each(function() {
    var fullname = $(this).data('tags');
    if(fullname) {
      var d = document.createElement('div');
      d.classList.add('tag-tooltip');
      d.innerHTML = fullname;
      var t = tippy('#'+$(this).attr('id'), {
        arrow: false,
        allowHTML: true,
        followCursor: false,
        html: d,
      });
    }
  });

  $('.show--subs').click(function(e) {
    e.preventDefault();
    $('#project_'+$(this).data('project')+'_subs').toggle();
    e.stopPropagation();
    return false;
  });

  $('#commentform #submit').click(function(e){
    if($(this).parent().prev().find('#comment').val() == '') {
      e.preventDefault();
      $('h3#reply-title').css('color','red');
    }
  });

  $('#cancel-comment-reply-link').click(function(e){
    $('h3#reply-title').css('color','#000');
  });

  $('textarea#comment').bind('input propertychange', function() {
    $('h3#reply-title').css('color','#000');
  });

});

var targetNodes = $('.cld-like-count-wrap');
var countObserver = new MutationObserver(mutationHandler);
var obsConfig = { childList: true, characterData: true, attributes: true, subtree: true };

targetNodes.each(function(){
    countObserver.observe(this, obsConfig);
} );

function mutationHandler (mutationRecords) {
  mutationRecords.forEach ( function (mutation) {
    if(typeof mutation.addedNodes == "object") {
      $(mutation.target).prev().each(function() {
        if($(this).attr('data-already-liked') != 1 && $(this).attr('data-unliked') != 1) {
          $(this).attr('data-already-liked',1);
          $(this).bind('click',unlikeClick);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event' : 'comment like',
            'user' : get_user_id()
          });
        }
      });
    }
  });
}

function get_user_id() {
  var user_id = 0;
  document.body.classList.forEach(cname => {
    if(cname.indexOf('user-') != -1) {
      user_id = cname.substring(cname.indexOf('-') + 1);
    }
  });
  return user_id;
}

function unlikeClick() {
  if($(this).attr('data-already-liked') == 1) {
    var btn = $(this);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=unlike&comment='+$(this).data('comment-id'),
      success: function (data) {
        //if(data) {
          btn.attr('data-unliked',1);
          btn.attr('data-already-liked',0);
          btn.off('click');
          btn.bind('click',likeClick);
          btn.next().text(data);
          /*if(data > 0) {
            btn.next().text(data);
          }
          else {
            btn.next().text('');
          }*/
        //}
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  }
}
function likeClick() {
  if($(this).attr('data-already-liked') == 0) {
    var btn = $(this);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: lm_ajax_script.ajaxurl,
      data: '&action=like&comment='+$(this).data('comment-id'),
      success: function (data) {
        if(data && data.likes && data.likes > 0) {
          btn.attr('data-unliked',0);
          btn.attr('data-already-liked',1);
          btn.off('click');
          btn.bind('click',unlikeClick);
          btn.next().text(data.likes);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          	'event' : 'comment like',
            'user' : data.user
          });
        }
      },
      error: function (request, status, error) {
        console.log(request.responseText);
      }
    });
  }
}

$('.cld-like-trigger[data-already-liked="1"]').click(unlikeClick);

$('html:lang(fr-FR) .um-register .um-form .um-right a.um-button').attr('href','/fr/login');
$('html:lang(fr-FR) .um-login .um-form .um-right a.um-button').attr('href','/fr/register');

$('html:lang(it-IT) .um-register .um-form .um-right a.um-button').attr('href','/it/login');
$('html:lang(it-IT) .um-login .um-form .um-right a.um-button').attr('href','/it/register');
